import React, { useState, useEffect } from 'react';

import Box from 'relements/build/esm/ui/box';
import SidebarV2 from '@haptik/helpers/build/esm/SidebarV2';
import CommonStore from '@src/stores/CommonStore';
import EditBot from '@src/components/BotModals/EditBot';
import EditTemplateDetailsModal from '@src/containers/Templates/Modals/EditTemplateDetailsModal';
import hashHistory from '@src/History';
import {
  openComponentModal,
  updateABTestingDrawerFlag,
  setRHSActive,
} from '@src/actions/BotActions';
import { getAllStories } from '@src/actions/StoryActions';
import BotStore from '@src/store';
import FindReplace from '@src/containers/Overlays/FindReplace';

import Options from './options';

function Sidebar() {
  const [domainData, setDomainData] = useState({});
  const [showSearch, setShowSearch] = useState(false);
  const currentDomainInStore = CommonStore.getMetaTags().domain;
  const canViewSmartSkill =
    BotStore.canViewEditSmartSkill() &&
    JSON.parse(localStorage.getItem('ww_iva'))?.isSmartSkill;
  const mixPanelTracker = BotStore.getMixPanel();
  const casName = BotStore.getCAS();
  const env = BotStore.getEnvironment();

  const openBotSettings = () => {
    const domain_data = domainData.id
      ? domainData
      : JSON.parse(localStorage.getItem('ww_iva'));
    openComponentModal(
      <EditBot
        botData={domain_data}
        allLanguages={CommonStore.getMetaTags().allLanguages}
      />,
      'Edit Bot',
      null,
      'close',
      null,
      null,
      null,
      'edit-bot-modal',
      true
    );
  };

  const openSmartSkillSettings = () => {
    const templateId = JSON.parse(localStorage.getItem('ww_iva')).id;
    openComponentModal(
      <EditTemplateDetailsModal templateId={templateId} />,
      'Edit Smart Skill Details',
      null,
      'close'
    );
  };

  const goToSkills = (path) => {
    const domainId =
      domainData.id || JSON.parse(localStorage.getItem('ww_iva')).id;
    const selectedStory = localStorage.getItem('selected_skillset');
    getAllStories(domainId, () => {
      const allStories = BotStore.getAllStories().filter((item) => item.active);
      if (allStories.length > 0) {
        const defaultStory = allStories[0].title.includes('Feedback')
          ? allStories.length > 1
            ? allStories[1]
            : allStories[0]
          : allStories[0];
        const storyPath = path({
          domainId,
          storyId: selectedStory || defaultStory.id,
        });
        hashHistory.push(storyPath);
      } else {
        hashHistory.push(`/bot/${domainId}`);
      }
    });
  };

  const onOptionClick = (option) => {
    updateABTestingDrawerFlag(false);
    setRHSActive(false);
    const domainId =
      domainData.id || JSON.parse(localStorage.getItem('ww_iva')).id;
    const domainName =
      JSON.parse(localStorage.getItem('ww_iva')).domain_name ||
      JSON.parse(localStorage.getItem('ww_iva')).title;
    const domainClient =
      JSON.parse(localStorage.getItem('ww_iva')).client || null;

    const isSmartSkill =
      JSON.parse(localStorage.getItem('ww_iva')).isSmartSkill || false;

    const mixPanelPayload = {
      'Bot Name': domainName,
      'Bot Account': domainClient,
      CAS: casName,
      Environment: env,
      'Is Smart Skill': isSmartSkill,
    };

    setShowSearch(false);
    if (option.actionType === 'openSetting') {
      openBotSettings();
    } else if (option.actionType === 'openSmartSkillSettings') {
      openSmartSkillSettings();
    } else if (option.actionType === 'openSkills') {
      goToSkills(option.path);
    } else if (option.actionType === 'showSearch') {
      setShowSearch(true);
    } else if (option.actionType === 'url') {
      const {
        partner_client_id: clientId = null,
      } = BotStore.getTestConfigData();
      const businessId = BotStore.getBusinessesLinkedToBot()?.[0]?.id;
      const data = {
        businessId,
        clientId,
        domainId,
      };
      hashHistory.push(option.path(data));
    }
    option.mixPanelEvent(mixPanelTracker, mixPanelPayload);
  };

  useEffect(() => {
    if (currentDomainInStore && domainData.id !== currentDomainInStore.id) {
      setDomainData(currentDomainInStore);
    }
  }, [domainData, currentDomainInStore]);

  const isSelected = (identifier) => {
    return identifier && window.location.hash.includes(identifier);
  };

  const renderSidebarOption = (option) => {
    const businessId = BotStore.getBusinessesLinkedToBot()[0]?.id;
    if (option.text === 'Business Manager' && !businessId) {
      return (
        <div style={{ opacity: 0.5, pointerEvents: 'none', padding: 0 }}>
          <SidebarV2.Option isActive={false} icon={option.icon} onClick={null}>
            {option.text}
          </SidebarV2.Option>
        </div>
      );
    }

    return (
      <SidebarV2.Option
        isActive={isSelected(option.identifier)}
        icon={option.icon}
        onClick={() => onOptionClick(option)}
      >
        {option.text}
      </SidebarV2.Option>
    );
  };

  const renderOptions = () => {
    const retData = [];
    Options.map((option) => {
      if (option.type === 'option') {
        if (option.text === 'Smart Skill Settings') {
          if (canViewSmartSkill) {
            retData.push(renderSidebarOption(option));
          }
        } else if (
          option.text === 'FAQs' ||
          option.text === 'Small Talks' ||
          option.text === 'AI Site Sync' ||
          option.text === 'AI Agents'
        ) {
          if (
            [2, 3,4].includes(domainData.domain_type) &&
            option.text === 'AI Agents'
          ) {
            retData.push(renderSidebarOption(option));
          } else if (
            ![2, 3,4].includes(domainData.domain_type) &&
            option.text !== 'AI Agents'
          ) {
            retData.push(renderSidebarOption(option));
          }
        } else retData.push(renderSidebarOption(option));
      } else {
        retData.push(<SidebarV2.Divider />);
      }
    });

    return retData;
  };

  return (
    <>
      <SidebarV2 hoverEffect>{renderOptions()}</SidebarV2>
      <FindReplace
        domain={domainData}
        active={showSearch}
        onClose={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setShowSearch(false);
        }}
      />
    </>
  );
}

export default Sidebar;
